import { useApiMutation, useApiQuery } from "@/hooks/use-api";
import {
  Branch,
  BranchLog,
  CreateBranchPayload,
  MergeBranchPayload,
  MergeResult,
} from "@/models/branch";
import { hasSelectedWorkspace } from "./core";

/**
 * Hook to fetch all branches for the current workspace.
 */
export const useBranches = () =>
  useApiQuery<Branch[]>(
    { url: "/branches" },
    { enabled: hasSelectedWorkspace(), staleTime: 2 * 60 * 1000 }
  );

/**
 * Hook to fetch branch logs, optionally filtered by branch ID.
 */
export const useBranchLogs = (branchId?: string | null) =>
  useApiQuery<BranchLog[]>(
    {
      url: "/branch_logs",
      params: branchId ? { branch_id: branchId } : undefined,
    },
    { enabled: hasSelectedWorkspace() }
  );

/**
 * Hook to create a new branch.
 */
export const useCreateBranch = () =>
  useApiMutation<Branch, CreateBranchPayload>({
    url: "/branches",
    method: "POST",
  });

/**
 * Hook to merge a branch into another.
 */
export const useMergeBranch = () =>
  useApiMutation<MergeResult, MergeBranchPayload, { id: string }>({
    url: "/branches/{id}/merge",
    method: "POST",
  });

/**
 * Hook to delete a branch.
 */
export const useDeleteBranch = () =>
  useApiMutation<{}, {}, { id: string }>({
    url: "/branches/{id}",
    method: "DELETE",
  });
